import moment from "moment";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";

const ReturnBranchList = () => {
  const navigate = useNavigate();
  const defaultColumns: any = [
    {
      header: "RTV/Return ID",
      accessorKey: "tracking_number",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Updated",
      accessorKey: "modified",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Branch",
      accessorKey: "destination_branch.name",
      cell: NACell,
    },
    // {
    //   header: "Driver",
    //   accessorKey: "driver.user.full_name",
    //   cell: NACell,
    // },
    {
      header: "Total Items",
      accessorKey: "items.total",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Received Items",
      accessorKey: "items.received",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Missing Items",
      accessorKey: "items.missing",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
  ];
  const handleEditNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };
  return (
    <>
      <DataTable
        queryKey={"return-branch"}
        url={APIS.RTV_BRANCH}
        tableName={"return-branch"}
        handleEditNavigate={handleEditNavigate}
        columns={defaultColumns}
        addNewPagePath={"/create"}
      />
    </>
  );
};

export default ReturnBranchList;
